export const LegendRow = ({
  swatch,
  title,
  description,
}: {
  swatch: React.ReactNode;
  title: string;
  description: string;
}) => (
  <div
    style={{
      display: "grid",
      gridTemplateColumns: "40px 1fr",
      gap: 10,
      alignItems: "center",
      padding: "4px 0",
    }}
  >
    <div style={{ display: "flex", justifyContent: "center" }}>{swatch}</div>
    <div>
      <div style={{ fontWeight: 600 }}>{title}</div>
      <div style={{ opacity: 0.75 }}>{description}</div>
    </div>
  </div>
);
